// Puerto del dominio (repository abstracto) para la información inicial.
// La implementación concreta vive en infrastructure y se enlaza por DI.
import { Observable } from 'rxjs';
import { InitialDataResponse } from '../../interfaces/initial-data/initial-data.interface';

export abstract class InitialDataRepository {
  abstract getAllInitialData(): Observable<InitialDataResponse>;
}
